import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import Tooltip from 'react-bootstrap/Tooltip'
import { getUIState } from '../../../../utils/selectors'

import { Button, Checkbox, FormGroup, LoadingIndicator, Popper } from '../../../../components'

const MESH_MEMBERS = {
  CARRYING: 'carryingMesh',
  CARRIED: 'carriedMesh',
  HANGER: 'hangerMesh',
}

const Illustration = (props) => {
  const modelRef = useRef()
  const graphicsData = useSelector((state) => getUIState(state).graphicsData)

  const [memberEnabled, setMemberEnabled] = useState({
    [MESH_MEMBERS.CARRYING]: true,
    [MESH_MEMBERS.CARRIED]: true,
    [MESH_MEMBERS.HANGER]: true,
  })

  const handleMemberEnabled = (e) => {
    const { name, checked } = e.target
    if (modelRef.current) {
      const model = modelRef.current

      model.handleMemberEnabled(name, checked)
      setMemberEnabled((prev) => ({ ...prev, [name]: checked }))
    }
  }

  const handleResetCameraView = () => {
    if (modelRef.current) {
      modelRef.current.handleFitCameraView()
    }
  }

  return (
    <div className="outputWrapper modelViewer3D" {...props}>
      <div className="paneHeader">
        <div className="paneHeader__staticHeading">3D Viewer</div>
      </div>

      <div className="w-full h-full">
        {graphicsData ? (
          <bp-hs-legacy
            ref={modelRef}
            carrying={JSON.stringify(graphicsData.carrying)}
            carried={JSON.stringify(graphicsData.carried)}
            hanger={JSON.stringify(graphicsData.hanger)}
            connection-type={graphicsData._connectionType}
            configuration={graphicsData._configuration}
            vertical-width={graphicsData._verticalWidth}
          />
        ) : (
          <LoadingIndicator />
        )}
        <div className="illustrationSection__actions">
          <div className="d-flex flex-column gap-y-4 p-4">
            <div>
              <Popper
                trigger={['hover', 'focus']}
                delay={0}
                overlay={
                  <Tooltip>
                    <p className="my-0">Reset View</p>
                  </Tooltip>
                }
              >
                <Button variant="" className="resetView-btn" onClick={handleResetCameraView}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z"
                      fill="#623C11"
                    />
                  </svg>
                </Button>
              </Popper>
            </div>
            <div>
              <p className="mt-0 mb-2">Object Visibility</p>
              <div className="d-flex flex-column gap-y-1">
                <FormGroup>
                  <Checkbox
                    name={MESH_MEMBERS.CARRYING}
                    label="Carrying"
                    checked={memberEnabled[MESH_MEMBERS.CARRYING]}
                    onChange={handleMemberEnabled}
                  />
                </FormGroup>
                <FormGroup>
                  <Checkbox
                    name={MESH_MEMBERS.CARRIED}
                    label="Carried"
                    checked={memberEnabled[MESH_MEMBERS.CARRIED]}
                    onChange={handleMemberEnabled}
                  />
                </FormGroup>
                <FormGroup>
                  <Checkbox
                    name={MESH_MEMBERS.HANGER}
                    label="Hanger"
                    checked={memberEnabled[MESH_MEMBERS.HANGER]}
                    onChange={handleMemberEnabled}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Illustration
